import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { AlertCircleIcon, Trash2 } from "lucide-react";
import { Alert, AlertTitle } from "@/components/ui/alert";
import { useDeletePlan } from "@/api/plan/delete-plan";

export default function DeletePackageDialog({ id, dialogOpen, onClose }: { id: string; dialogOpen: boolean; onClose: () => void }) {
    const { mutate: deletePlan, isPending } = useDeletePlan();

    return (
        <Dialog open={dialogOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Package</DialogTitle>
                </DialogHeader>

                <DialogDescription className="flex items-center justify-center flex-col gap-2">
                    <div className="flex items-center gap-2 bg-red-200 p-4 rounded-full">
                        <Trash2 className="text-red-600" />
                    </div>
                    <p className="text-lg">Are you sure you want to delete this package?</p>
                    <Alert variant="destructive" className="flex items-center justify-center gap-2">
                        <AlertCircleIcon />
                        <AlertTitle>This cannot be undone.</AlertTitle>
                    </Alert>
                </DialogDescription>

                <DialogFooter>
                    <Button
                        onClick={() => {
                            deletePlan({ id });
                            onClose();
                        }}
                        type="submit"
                        variant={"destructive"}
                        className="mt-2"
                        disabled={isPending}
                    >
                        {isPending ? "Deleting..." : "Delete Package"}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
